import { styled } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
`;

const StyledParkingSlotsContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	user-select: none;
`;

const StyledParkingSlotsLabels = styled.div`
	height: 20px;
	font-family: 'GT Walsheim Pro';
	font-weight: bold;
	font-size: 18px;
	color: black;

	span {
		font-weight: normal;
		font-size: 16px;
		color: rgba(0, 0, 0, 0.5);
	}
`;

const StyledAddSlotsButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 6px;
	background-color: #1f8034;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		width: 10px;
		height: 10px;
		transition: filter 0.3s ease;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledParkingSlotsFull = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: #c71e1e;
	margin-right: 8px;

	transition: opacity 0.3s;
	opacity: 0;

	&.fade-enter {
		opacity: 0;
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		opacity: 1;
	}

	&.fade-exit-active {
		opacity: 0;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

export {
	StyledAddSlotsButton,
	StyledContainer,
	StyledParkingSlotsContainer,
	StyledParkingSlotsFull,
	StyledParkingSlotsLabels,
};
